import { Form, FormInstance } from "antd";
import { CustomModal } from "../../../lib/CustomModal";
import { FormItems } from "./FormItems";
import { useCallback, useState } from "react";

type ExportModalProps = {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export const ExportModal = ({ isOpen, setIsOpen }: ExportModalProps) => {
  const [form]: FormInstance[] = Form.useForm();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const onChangeIsOpen = useCallback(
    (value: boolean): void => {
      if (!isLoading) {
        setIsOpen(value);
        form.resetFields();
      }
    },
    [form, setIsOpen, isLoading]
  );

  return (
    <CustomModal
      isModalOpen={isOpen}
      setIsModalOpen={onChangeIsOpen}
      width={400}
      titleText="Export to ACH Payments File"
      headerClass="processing-print-modal--header"
      modalClass="processing-print-modal"
    >
      <FormItems
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        form={form}
        onChangeIsOpen={onChangeIsOpen}
      />
    </CustomModal>
  );
};
